import * as React from 'react'
import { Box, Typography } from "@mui/material"


export default function numDaysColumn() {
    return {
        name: 'numDays', label: 'Num Days Available',
        options: {
			headerAlign: 'left',
            customBodyRowRenderLite: (value) => <Box>
                <Typography variant="caption">
                    {`${value} ${value > 1 ? 'days' : 'day'}`}
                </Typography>
            </Box>
        }
    }
}